import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import MaritalStatusList from "./MaritalStatusList";

export default {
  list: MaritalStatusList,
  icon: AssignmentIndIcon,
};
